import React from 'react';
import { CTAButton } from './CTAButton';
import { images } from '../data/checkout';
export function FinalCTA() {
  return <section className="bg-brand-deep px-4 py-16 text-white sm:px-6 md:py-24" data-id="element-116" data-mp="3udp08safhoqj">
      <div className="mx-auto max-w-3xl text-center" data-id="element-117" data-mp="c70wp6v119mz">
        <h2 className="font-serif text-[32px] font-bold leading-[1.12] sm:text-4xl md:text-5xl" data-id="element-118" data-mp="c4fuggqtgrop">
          Are you ready for a more structured approach to obesity care?
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-white/80 sm:text-lg" data-id="element-119" data-mp="m341kkh9jmdm">
          You don't need to rebuild your reference materials every time you prepare a consultation. Start with a
          structured system designed to help you organize obesity assessments, treatment reviews, and ongoing follow-up.
        </p>
        <img src={images.hero} alt="Obesity Clinical Blueprint™ collection" className="mx-auto mt-8 w-full max-w-xl" loading="lazy" data-id="element-120" data-mp="14vg0ex8pk5j0" />
        <div className="mt-8" data-id="element-121" data-mp="zxegyb7de470">
          <CTAButton label="Yes, I want Obesity Clinical Blueprint™" note="Just $27 USD · Instant Digital Download · One-Time Payment · 7-Day Money-Back Guarantee" onDark data-id="element-122" data-mp="zy6e3qgm89ze" />
        </div>
      </div>
    </section>;
}